import { useCallback, useContext } from "react";
import { PostsPanel } from "@radarly/models/panel";
import { Action } from "../action";
import ChannelContext from "../context";
export function useOpenPostsPanel() {
  const { dispatch } = useContext(ChannelContext);
  return useCallback(
    (data: PostsPanel["data"]) => {
      dispatch(
        Action.panelOpened({
          type: "posts",
          data,
        })
      );
    },
    [dispatch]
  );
}
